module.exports = __webpack_public_path__ + "img/9788961570565.6c84ce6f.jpg";